import React from 'react';
import { CondensedLarge } from '@axiom/ui';
import type { Candidate } from '@axiom/validation';

import { CandidateUtil } from '../../utils/candidate-util';

export const BULK_OPEN_TALENT_LIMIT = 10;
export const BULK_OPEN_BIO_LIMIT = 10;
export const BULK_DOWNLOAD_BIO_LIMIT = 25;

export const TalentBulkActionsUtil = {
  splitBioRows(rows: Candidate[]) {
    const skipped = rows.filter(
      row => CandidateUtil.getBioDisposition(row) === 'skip'
    );
    const eligible = rows.filter(
      row => CandidateUtil.getBioDisposition(row) !== 'skip'
    );
    const anonymous = rows.filter(
      row => CandidateUtil.getBioDisposition(row) === 'anonymous'
    );

    return { skipped, eligible, anonymous };
  },

  buildBulkBioToastChildren({
    presentParticiple,
    pastParticiple,
    eligible,
    skipped,
    anonymous,
  }: {
    presentParticiple: string;
    pastParticiple: string;
    eligible: Candidate[];
    skipped: Candidate[];
    anonymous: Candidate[];
  }) {
    return (
      <>
        <CondensedLarge name="BULK_BIO_TOAST_COUNT">
          {presentParticiple} {eligible.length}{' '}
          {eligible.length === 1 ? 'bio' : 'bios'}.
        </CondensedLarge>
        {skipped.length > 0 ? (
          <CondensedLarge name="BULK_BIO_TOAST_SKIPPED">
            {skipped.length} talent skipped due to inappropriate status:{' '}
            {skipped.map(row => row.calculatedDisplayName).join(', ')}.
          </CondensedLarge>
        ) : null}
        {anonymous.length > 0 ? (
          <CondensedLarge name="BULK_BIO_TOAST_ANONYMOUS">
            {anonymous.length} talent {pastParticiple} as anonymous due to not
            being available for proactive sharing:{' '}
            {anonymous.map(row => row.calculatedDisplayName).join(', ')}.
          </CondensedLarge>
        ) : null}
      </>
    );
  },
};
